import { css } from '@emotion/react';
import { ColorPalette } from './ColorPalette';

interface ErrorViewProps {
  error: Error;
}

export default function ErrorView({ error }: ErrorViewProps) {
  return (
    <div css={styles.container}>
      <span css={styles.label}>Error</span>
      <span css={styles.message}>{error.message}</span>
    </div>
  );
}

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: 24,
  }),
  label: css({
    color: ColorPalette.tyrosRed,
    fontSize: 14,
    fontWeight: 600,
  }),
  message: css({
    color: ColorPalette.normalText,
    fontSize: 14,
  }),
};
